/**
 * directive
 * 指令
 */
import Vue from "vue";
import common from "@/assets/js/comm.js";

const hasPermission = (el, bind, vnode) => {
  let PermissionArr = JSON.parse(sessionStorage.getItem("btnPermiss")) || [];
  PermissionArr.push("aaaaa");
  let flag = false;
  const permission = bind.value;
  let permissionVal = bind.value;
  if (permission instanceof Function) {
    permissionVal = permission();
  }
  for (let i = 0; i < PermissionArr.length; i++) {
    const item = PermissionArr[i];
    if (item === permissionVal) {
      return true;
    }
  }
  return false;
};

Vue.directive("permission", {
  terminal: true,
  priority: 1000,
  params: ["test"],
  bind(el, bind, vnode) {
    const hasPermiss = hasPermission(el, bind, vnode);
    if (hasPermiss) {
      return;
    }
    // 创建一个注释元素
    const comment = document.createComment(" ");
    // 设置value值
    Object.defineProperty(comment, "setAttribute", {
      value: () => undefined,
    });
    // 用注释节点替换 当前页面元素
    vnode.elm = comment;
    // 下面作为初始化操作 赋值为空
    vnode.text = " ";
    vnode.isComment = true;
    vnode.context = undefined;
    vnode.tag = undefined;
    vnode.data.directives = undefined;
    el.parentNode && el.parentNode.removeChild(el);
  },
});
